import { render, staticRenderFns } from "./InterventionEditorConfig.vue?vue&type=template&id=49c1e0de&"
import script from "./InterventionEditorConfig.vue?vue&type=script&lang=js&"
export * from "./InterventionEditorConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports